<template>
  <div class="home-box">
    <div class="w">
      <div class="wl-title1">
        <div class="gang"></div>
        <div class="t">
          <!-- PolySmartChain 有何优势 -->
          {{ $t("home.box5T") }}
        </div>
        <div class="gang"></div>
      </div>
      <div class="box1">
        <div class="box11">
         
          <div class="p pfont">
            <!-- 使用 Solidity 和您已经熟悉的工具开始在 PSC 上构建 -->
            {{ $t("home.box5LP") }}
          </div>
          <a href="javascript:;">
            <div class="but" @click="uti.goPath(store.link.home.box5But)">
              <!-- 阅读文档 -->
              {{ $t("home.box5LBut") }}
            </div>
          </a>
        </div>
        <div class="box12">
          <div class="code" v-html="codeHtml"></div>
        </div>
      </div>
      <div class="box2">
        <div
          class="wl-item1"
          v-for="(item, index) in $t('home.box5ItemList')"
          :key="index"
        >
          <div class="img">
            <img
              :src="require(`../../assets/images/v4/home/box5${index + 1}.png`)"
              alt=""
            />
          </div>
          <div class="t">{{ item.title }}</div>
          <div class="link"></div>
          <div class="p pfont">{{ item.text }}</div>
       
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Store from "../../store";
export default {
  data() {
    return {
      uti: Store.uti,
      store: Store.state,
      codeHtml: `<p><span style="font-size: 16px;"><span style="color: #E36C09;"><br/></span></span></p><p>&nbsp;&nbsp;&nbsp;&nbsp;1&nbsp;&nbsp;&nbsp;&nbsp;</p><p><span style="font-size: 16px;"><span style="color: #E36C09;">&nbsp;&nbsp;</span>&nbsp;&nbsp;2&nbsp;&nbsp;&nbsp;<span style="color: #E36C09;">&nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;pragma&nbsp; solidity</span>&nbsp;&nbsp;<span style="color: #00B0F0;">^0.7.0</span><span style="color: #4BACC6;">;</span></span></p><p><span style="font-size: 16px;"><span style="color: #4BACC6;">&nbsp;&nbsp;&nbsp;&nbsp;</span>3</span></p><p><span style="font-size: 16px;"><span style="color: #00B0F0;">&nbsp;</span>&nbsp;&nbsp;&nbsp;4&nbsp;<span style="color: #00B0F0;">&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; contract</span>&nbsp; PSCMint&nbsp;&nbsp;<span style="color: #00B050;">is&nbsp;&nbsp;</span>Initializable {</span></p><p><span style="font-size: 16px;">&nbsp;&nbsp;&nbsp;&nbsp;5&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; // define&nbsp; used&nbsp; libs</span></p><p><span style="font-size: 16px;">&nbsp;&nbsp;&nbsp;&nbsp;6&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;<span style="color: #E36C09;">using&nbsp;&nbsp;</span>SafeMath&nbsp;<span style="color: #E36C09;"> for&nbsp; uint256</span>;&nbsp; &nbsp; &nbsp; &nbsp;&nbsp;</span></p><p style="line-height: normal;"><span style="font-size: 16px;">&nbsp;&nbsp;&nbsp;&nbsp;7&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; using&nbsp;&nbsp;Address&nbsp;&nbsp;for&nbsp; address;</span></p><p><span style="font-size: 16px;">&nbsp;&nbsp;&nbsp;&nbsp;8&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;<span style="color: #E36C09;">using&nbsp;&nbsp;</span>SafeERC20&nbsp;&nbsp;<span style="color: #E36C09;">for&nbsp;&nbsp;</span>ERC20;&nbsp; &nbsp;</span></p><p><span style="font-size: 16px;">&nbsp;&nbsp;&nbsp;&nbsp;9&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;<br/></span></p><p><span style="font-size: 16px;">&nbsp;&nbsp;&nbsp;&nbsp;10&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; IPSCMintAddressProvider&nbsp;&nbsp;<span style="color: #00B050;">public&nbsp;&nbsp;</span>addressProvider;</span></p><p><span style="font-size: 16px;">&nbsp;&nbsp;&nbsp;&nbsp;11&nbsp;&nbsp;&nbsp;&nbsp;</span></p><p><span style="font-size: 16px;"><span style="color: #00B0F0;">&nbsp;</span>&nbsp;&nbsp;&nbsp;12&nbsp;<span style="color: #00B0F0;">&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; function</span> initialize(&nbsp;<span style="color: #00B0F0;">address&nbsp;&nbsp;</span>owner,&nbsp;&nbsp;<span style="color: #00B0F0;">address&nbsp;&nbsp;</span></span></p><p><span style="font-size: 16px;">&nbsp;&nbsp;&nbsp;&nbsp;13&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;_addressProvider)&nbsp;&nbsp;<span style="color: #00B050;">public&nbsp;&nbsp;</span>initializer&nbsp; {</span></p><p><span style="font-size: 16px;">&nbsp;&nbsp;&nbsp;&nbsp;14</span></p><p><span style="font-size: 16px;">&nbsp;&nbsp;&nbsp;&nbsp;15&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;addressProvider&nbsp; =&nbsp; PSCProvider(_addressProv</span></p><p><br/></p>`,
    };
  },
};
</script>

<style lang="less" scoped>
.home-box {
  // height: 100vh;
  height: 1220px;
  background-image: url("../../assets/images/v4/home/box5Bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding-top: 202px;

  box-sizing: border-box;
  .box1 {
    // height: 328px;
    // background-color: pink;
    margin-top: 93px;
    display: flex;
    .box11 {
      flex: 1;
      .t {
        // width: 400px;
        height: 57px;
        font-size: 8px;

        font-weight: 500;
        color: #ffffff;
        margin-top: 23px;
      }
      .p {
        width: 647px;
        height: 100px;
        font-size: 16px;
        line-height: 25px;
        font-weight: 400;
        color: #ffffff;
        margin-top: 26px;
      }
      .but {
        // width: 180px;
        display: inline-block;
        padding: 0 50px;
        height: 54px;
        line-height: 54px;
        background: rgba(255, 255, 255, 0.91);
        box-shadow: 0px 5px 20px 0px rgba(26, 77, 143, 0.5);
        border-radius: 27px;
        margin-top: 37px;
        color: #000;
        a {
          color: #000;
        }
      }
    }
    .box12 {
      width: 564px;
      // height: 328px;
      background: #ffffff;
      box-shadow: 4px 4px 20px 0px rgba(37, 93, 150, 0.5);
      border-radius: 10px;
      font-family: ubuntu;
    }
  }
  .box2 {
    display: flex;
    justify-content: space-between;
    margin-top: 116px;
    .wl-item1 {
      width: 330px;
      height: 388px;
      padding : 0 20px 166px;
      background: #ffffff;
      border-radius: 10px;
      .img {
        margin-top: 35px;
      }
      .t {
        margin-top: 20px;
      }
      .more {
        transition: 1s;
        opacity: 0;
      }
    }
    .wl-item1:hover {
      margin-top: -50px;
      height: 388px;
      .more {
        opacity: 1;
      }
    }
  }
}
</style>
